module.exports = __webpack_public_path__ + "img/temp-ad-leaderboard.8fd363eb.png";